import React from 'react';

export const GridHelper: React.FC<unknown> = () => (
    //@ts-ignore
    <dsd-grid-helper></dsd-grid-helper>
);
